import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Align Vertical Center"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */

@Component({
    selector: 'app-icon-align-vertical-center',
    templateUrl: './icon-align-vertical-center.component.html',
    styleUrls: ['./icon-align-vertical-center.component.scss'],
    standalone: false
})
export class IconAlignVerticalCenterComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
